import { TriggerScore } from "../api/models/fraud.models";

export const contactAsBot: string = '@AMLOfficer_Support';

export const TriggersList: TriggerScore[] = [
  {
    nameEn: 'Child abuse material',
    nameRu: 'Материалы с насилием над детьми',
    risk: 'HIGH'
  },
  {
    nameEn: 'Sanctioned jurisdiction',
    nameRu: 'Санкционированная юрисдикция',
    risk: 'HIGH'
  },
  {
    nameEn: 'Sanctions',
    nameRu: 'Санкции',
    risk: 'HIGH'
  },
  {
    nameEn: 'Special measures',
    nameRu: 'Специальные меры',
    risk: 'HIGH'
  },
  {
    nameEn: 'Terrorist financing',
    nameRu: 'Финансирование терроризма',
    risk: 'HIGH'
  },
  {
    nameEn: 'Darknet market',
    nameRu: 'Даркнет рынок',
    risk: 'HIGH'
  },
  {
    nameEn: 'Fraud shop',
    nameRu: 'Мошеннический магазин',
    risk: 'HIGH'
  },
  {
    nameEn: 'Gambling',
    nameRu: 'Азартные игры',
    risk: 'HIGH'
  },
  {
    nameEn: 'High risk exchange',
    nameRu: 'Биржа высокого риска',
    risk: 'HIGH'
  },
  {
    nameEn: 'Illicit actor-org',
    nameRu: 'Незаконные организации',
    risk: 'HIGH'
  },
  {
    nameEn: 'Malware',
    nameRu: 'Вредоносное ПО (malware)',
    risk: 'HIGH'
  },
  {
    nameEn: 'Mixing',
    nameRu: 'Миксеры',
    risk: 'HIGH'
  },
  {
    nameEn: 'Online pharmacy',
    nameRu: 'Онлайн аптека',
    risk: 'HIGH'
  },
  {
    nameEn: 'Protocol privacy',
    nameRu: 'Конфиденциальность протоколов',
    risk: 'HIGH'
  },
  {
    nameEn: 'Ransomware',
    nameRu: 'Вымогательское ПО (ransomware)',
    risk: 'HIGH'
  },
  {
    nameEn: 'Scam',
    nameRu: 'Мошенничество',
    risk: 'HIGH'
  },
  {
    nameEn: 'Stolen funds',
    nameRu: 'Украденные средства',
    risk: 'HIGH'
  },
  {
    nameEn: 'ATM',
    nameRu: 'Банкомат',
    risk: 'MEDIUM'
  },
  {
    nameEn: 'Bridge',
    nameRu: 'Кроссчейн-мост',
    risk: 'MEDIUM'
  },
  {
    nameEn: 'Decentralized exchange',
    nameRu: 'Децентрализованная биржа',
    risk: 'MEDIUM'
  },
  {
    nameEn: 'Hosted wallet',
    nameRu: 'Хостинговый кошелек',
    risk: 'MEDIUM'
  },
  {
    nameEn: 'Merchant services',
    nameRu: 'Торговые услуги',
    risk: 'MEDIUM'
  },
  {
    nameEn: 'P2P exchange',
    nameRu: 'P2P биржа',
    risk: 'MEDIUM'
  },
  {
    nameEn: 'UnnameEnd service',
    nameRu: 'Неопознанные сервисы',
    risk: 'MEDIUM'
  },
  {
    nameEn: 'Exchange',
    nameRu: 'Биржа',
    risk: 'LOW'
  },
  {
    nameEn: 'ICO',
    nameRu: 'ICO',
    risk: 'LOW'
  },
  {
    nameEn: 'Infrastructure as a service',
    nameRu: 'Инфраструктура как услуга',
    risk: 'LOW'
  },
  {
    nameEn: 'Lending',
    nameRu: 'Кредитование',
    risk: 'LOW'
  },
  {
    nameEn: 'Mining',
    nameRu: 'Майнинг',
    risk: 'LOW'
  },
  {
    nameEn: 'Mining pools',
    nameRu: 'Пулы майнинга',
    risk: 'LOW'
  },
  {
    nameEn: 'NFT platform - collection',
    nameRu: 'Платформы NFT',
    risk: 'LOW'
  },
  {
    nameEn: 'Other',
    nameRu: 'Другое',
    risk: 'LOW'
  },
  {
    nameEn: 'Seized funds',
    nameRu: 'Изъятые средства',
    risk: 'LOW'
  },
  {
    nameEn: 'Smart contract',
    nameRu: 'Смарт-контракт',
    risk: 'LOW'
  },
  {
    nameEn: 'Token smart contract',
    nameRu: 'Сокен смарт-контракт',
    risk: 'LOW'
  },
];

export const CoinsForNetworkList = {
  trx: [
    'usdt', 'wbt', 'btt', 'trx', 'sun',
    'usdj', 'usdd', 'flux', 'usdc', 'sundog',
    'eth', 'ltc', 'doge', 'bull', 'suncat',
    'ivfun', 'sundog', 'apenft', 'htx', 'shib',
    'mntc', 'ama', 'prch', 'altl', 'sun',
  ],
  eth: [
    'usdt', 'bnb', 'usdc', 'steth', 'wbtc',
    'link', 'und1', 'shib', 'dot', 'weeth',
    'dai', 'xrp', 'near', 'wh-btc', 'mnt',
    'pol', 'fdusd', 'arb', 'bounce-btc', 'imx',
    'usde', 'flux', 'cmcx', 'link', 'usdt',
  ],
  bsc: [
    'usdt', 'eth', 'binance-peg', 'xrp', 'silbnb',
    'bnb', 'usdc', 'cardano', 'doge', 'trx',
    'wbtc', 'link', 'ltc', 'avax', 'usde',
    'shib', 'btc', 'dai', 'near', 'weth',
    'bittorrent', 'pol', 'apenft', 'usdj', 'stellar',
  ]
};

export const CoinsListStartPage = [
  'btc', 'eth', 'usdt', 'sui', 'xrp',
  'usdc', 'trx', 'cardano', 'dai', 'ltc',
  'doge', 'wh-btc', 'pol', 'wbtc', 'link',
  'htx', 'shib', 'mntc', 'ama', 'prch',
  'altl', 'sun', 'arb', 'usdj', 'stellar',
]
